export default "__VITE_ASSET__Cwl0UNvO__"